export const size: Record<string, string> = {
  none: "0",
  one: "0.1rem",
  two: "0.2rem",
  three: "0.3rem",
  six: "0.6rem",
  ten: "1rem",
  size1: "0.4rem",
  size2: "0.8rem",
  size3: "1.2rem",
  size4: "1.6rem",
  size5: "2rem",
  size6: "2.4rem",
  size7: "2.8rem",
  size8: "3.2rem",
  size9: "3.6rem",
  size10: "4rem",
  size11: "4.4rem",
  size12: "4.8rem",
  size13: "5.2rem",
  size14: "5.6rem",
  size15: "6rem",
  size16: "6.4rem",
  size18: "7.2rem",
  size20: "8rem",
  size78: "7.8rem",
  size88: "8.8rem",
  size90: "9rem",
  size100: "10rem",
  size120: "12rem",
  size260: "18rem",
};

export const mediaQueries: Record<string, string> = {
  xxsm: "320px",
  xsm: "480px",
  sm: "768px",
  mdAlt: "992px",
  md: "1024px",
  lg: "1200px",
  xlg: "1440px",
  xxlg: "1920px",
};

export const tokens = {
  colors: {
    violet: "#5964e0",
    violetLight: "#939bf4",
    darkBlue: "#19202d",
    black: "#121721",
    gray: "#9daec2",
    grayDark: "#6e8098",
    grayLight: "#f4f6f8",
    white: "#fff",
    lightOverlay: "rgba(255,255,255,.8)",
    darkOverlay: "rgba(0,0,0,.8)",
  },
  fontWeight: {
    regular: 400,
    demi: 500,
    bold: 700,
  },
  font: {
    headings: "Quattrocento, serif",
    fontFamily: "Quattrocento Sans, sans-serif",
  },
  fontSize: {
    fontSize1: "1.4rem",
    fontSize2: "1.6rem",
    fontSize3: "2rem",
    fontSize4: "2.4rem",
    fontSize5: "2.8rem",
  },
  letterSpacing: {
    dense: "-.25rem",
    tight: "-.15rem",
    sparse: ".1rem",
    double: ".2rem",
  },
  lineHeight: {
    lineHeight1: "1.8rem",
    lineHeight2: "2.4rem",
    lineHeight3: "2.6rem",
    lineHeight4: "2.9rem",
    lineHeight5: "3.4rem",
    lineHeightMultiplierSmall: "1.3",
    lineHeightMultiplierMedium: "1.5",
    lineHeightMultiplierLarge: "2",
  },
  curve: {
    linear: "cubic-bezier(0, 0, 1, 1)",
    ease: "cubic-bezier(0.25, 0.1, 0.25, 1)",
    easeSlow: "cubic-bezier(0.35, 0, 0.5, 1)",
    easeQuick: "cubic-bezier(0.35, 0, 0.25, 1)",
    easeCalm: "cubic-bezier(0.12, 0, 0.39, 0)",
    easeEntrance: "cubic-bezier(0, 0, 0.1, 1)",
    easeExit: "cubic-bezier(0.35, 0, 0.8, 1)",
    easeSpirited: "cubic-bezier(0.35, 1.3, 0.3, 1)",
    easeEntranceSpirited: "cubic-bezier(0.15, 1.3, 0.3, 1)",
    easeExitSpirited: "cubic-bezier(0.7, -0.1, 0.6, 0.1)",
    easeInSine: "cubic-bezier(0.12, 0, 0.39, 0)",
    easeOutSine: "cubic-bezier(0.61, 1, 0.88, 1)500ms",
  },
  elevation: {
    none: "0 0 0 0 rgba(0, 0, 0, 0.2)",
    skim: "0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.2)",
    lifted: "0 0.2rem 0.8rem 0 rgba(0, 0, 0, 0.2)",
    raised: "0 0.4rem 1.6 0 rgba(0, 0, 0, 0.2)",
    floating: "0 0.6rem 2.4rem 0 rgba(0, 0, 0, 0.2)",
  },
  opacity: {
    none: "0",
    opacity10: "0.1",
    opacity13: "0.13",
    opacity20: "0.2",
    opacity25: "0.25",
    opacity30: "0.3",
    opacity33: "0.33",
    opacity40: "0.4",
    opacity50: "0.5",
    opacity60: "0.6",
    opacity70: "0.7",
    opacity80: "0.8",
    opacity90: "0.9",
    opacity100: "1",
    opacityDisabled: "0.5",
    opacity03: "0.03",
    opacity07: "0.07",
    opacityShadow: "0.2",
  },
  radius: {
    default: "0.4rem",
    none: "0",
    xSmall: "0.2rem",
    small: "0.4rem",
    medium: "0.6rem",
    large: "0.8rem",
    xLarge: "1.5rem",
    circle: "50%",
    pill: "9999rem",
  },
  spacing: {
    ...size,
  },
  size,
  duration: {
    paused: "paused",
    slow: "3s",
    fast: "500ms",
    zero: "0.0s",
    time1: "0.05s",
    time2: "0.1s",
    time3: "0.15s",
    time4: "0.25s",
    time5: "0.35s",
    time6: "0.5s",
    time7: "0.75s",
    time8: "1.0s",
    time9: "1.5s",
    time10: "2.0s",
    time11: "3.0s",
    time12: "4.0s",
  },
} as const;
